module.exports = __webpack_public_path__ + "static/media/abbiamo11.4e525565.png";